export default (endValue2) => endValue2 === 100 || endValue2 === 0;
